"use strict";

export default function blogSearch() {
    const panel = document.querySelector("[data-blog-search-panel]");
    if (!panel) return;

    const toggleBtns = document.querySelectorAll("[data-blog-search-toggle]");
    const input = panel.querySelector("[data-blog-search-input]");

    // Open panel automatically if a search term is already in the URL
    if (new URLSearchParams(window.location.search).get("busca")) {
        panel.classList.add("is-open");
    }

    toggleBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const isOpen = panel.classList.contains("is-open");
            if (isOpen) {
                closePanel();
            } else {
                openPanel();
            }
        });
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closePanel();
    });

    document.addEventListener("click", (e) => {
        if (
            panel.classList.contains("is-open") &&
            !panel.contains(e.target) &&
            ![...toggleBtns].some((b) => b.contains(e.target))
        ) {
            closePanel();
        }
    });

    function openPanel() {
        panel.classList.add("is-open");
        setTimeout(() => input.focus(), 50);
    }

    function closePanel() {
        panel.classList.remove("is-open");
    }
}
